import { createReducer } from '@reduxjs/toolkit';
import { initAppAction } from '@store/app/actions';
import { AppState } from '@store/app/types';

const initialState: AppState = {
    locale: 'ru',
    isAppInit: false,
    apiPrefix: '',
};

export const appReducer = createReducer(initialState, (builder) => {
    builder.addCase(initAppAction, (state, action) => {
        state.apiPrefix = action.payload.apiPrefix;
        state.locale = action.payload.locale;
        state.isAppInit = true;
    });
});
